export default __webpack_public_path__ + "static/media/51cea5ba116cbfb353c626ab597e2913.svg";